import { ArrowRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import io from "socket.io-client";
// import useSocket from "../useSocket";
import ButtonLoading from "../ButtonLoading";
import { useSocket } from "../../context/SocketContext";

// const socket = io("http://localhost:5000");

const MatchCard = ({ listing }) => {
  const { socket } = useSocket(); // Backend URL

  const { authenticated } = useAuth();
  const [userParticipation, setUserParticipation] = useState();
  const [participants, setParticipants] = useState();
  const [newListing, setNewListing] = useState();
  const [matchDate, setMatchDate] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setNewListing(listing);
    // console.log(listing?.participants, "new listinf");
    setLoading(true);
    const userParticipated = listing?.participants?.filter(
      (participantId) => participantId === authenticated?.user?._id
    );
    setUserParticipation(userParticipated);
    setLoading(false);

    const date = new Date(listing?.closingTime);
    const options = {
      month: "long", // Full month name
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Enable am/pm formatting
    };
    const formattedDate = date
      .toLocaleString("en-US", options)
      .replace(",", "");
    // console.log(formattedDate);
    setMatchDate(formattedDate);

    setParticipants(listing.participants);
  }, []);

  useEffect(() => {
    // Listen for real-time updates
    socket?.on("matchUpdated", (change) => {
      if (
        change?.updateDescription?.updatedFields &&
        change?.documentKey?._id === listing._id
      ) {
        console.log(
          "Real-time update received of match card :",
          change?.updateDescription?.updatedFields
        );

        if (change?.updateDescription?.updatedFields.participants) {
          console.log("detetcted");
          setNewListing((prevState) => ({
            ...prevState, // Spread the previous state
            // Spread the previous user object
            participants: change?.updateDescription?.updatedFields.participants, // Only update the participants field
          }));
        } else {
          setNewListing((prevState) => ({
            ...prevState, // Spread the previous state
            // Spread the previous user object
            ...change?.updateDescription?.updatedFields,
          }));
        }
      }

      // setParticipants(change);
    });

    // Cleanup on unmount
    return () => {
      socket?.off("matchUpdated");
    };
  }, [newListing]);

  useEffect(() => {
    // Listen for real-time updates
    socket?.on("changeMatchParticipants", (change) => {
      console.log(
        "Real-time update received of match card update participants:",
        change?.change?.updateDescription?.updatedFields
      );
      if (
        change?.change.updateDescription?.updatedFields &&
        change?.change.documentKey?._id === listing._id
      ) {
        if (change?.change.updateDescription?.updatedFields.participants) {
          console.log("detetcted");
          setNewListing((prevState) => ({
            ...prevState, // Spread the previous state
            // Spread the previous user object
            participants:
              change?.change.updateDescription?.updatedFields.participants, // Only update the participants field
          }));
        } else {
          setNewListing((prevState) => ({
            ...prevState, // Spread the previous state
            // Spread the previous user object
            ...change?.updateDescription?.updatedFields,
          }));
        }
      }

      // setParticipants(change);
    });

    // Cleanup on unmount
    return () => {
      socket?.off("matchUpdated");
    };
  }, [newListing]);

  return (
    <div className="flex px-3 py-3 ">
      <div className="max-w-sm rounded  bg-black bg-opacity-80 overflow-hidden shadow-lg">
        {newListing ? (
          <>
            <div className="relative z-0">
              {newListing?.type == "single" ? (
                <img
                  className="w-full h-[130px]"
                  src="https://www.pubgmobile.com/images/event/home/part6.jpg"
                  alt="Sunset in the mountains"
                />
              ) : newListing?.type == "duo" ? (
                <img
                  className="w-full h-[130px]"
                  src="https://www.pubgmobile.com/images/event/home/part4.jpg"
                  alt="Sunset in the mountains"
                />
              ) : (
                <img
                  className="w-full h-[130px]"
                  src="https://www.pubgmobile.com/images/event/home/part3.jpg"
                  alt="Sunset in the mountains"
                />
              )}

              {/* for squad https://www.pubgmobile.com/images/event/home/part3.jpg
          for duo https://www.pubgmobile.com/images/event/home/part4.jpg */}
              <div className="absolute top-0 right-0">
                <div className="w-32 h-8 absolute top-4 -right-8">
                  <div
                    className={`h-full w-full ${
                      newListing?.participants?.length !==
                      newListing?.totalSlots
                        ? "bg-green-500"
                        : "bg-red-500"
                    }  text-white text-center leading-8 font-semibold transform rotate-45 `}
                  >
                    {newListing?.participants?.length ==
                      newListing?.totalSlots ||
                    newListing.status == "finished" ||
                    newListing.status == "started" ? (
                      <p>Closed</p>
                    ) : (
                      <p>Open</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="absolute rounded top-0 left-0">
                <div className="w-32 h-8 absolute top-2 rounded  left-2 ">
                  <div className="h-full rounded-full w-full bg-black bg-opacity-80 text-yellow-500 text-center leading-8 font-semibold transform ">
                    {newListing?.game}
                  </div>
                </div>
              </div>
            </div>
            <div className="px-6 py-4">
              <div> {matchDate}</div>
              <div className="font-bold text-xl mb-2">Match Details </div>

              <div className="flex  items-center"></div>

              <div className="flex mt-2  items-center">
                <p className="text-xs me-2">Match Type : </p>
                <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
                  {newListing?.matchtype}
                </p>
              </div>
              <div className="flex mt-2 justify-between">
                <div className="flex   items-center">
                  <p className="text-xs me-2">Server : </p>
                  <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
                    {newListing?.server}
                  </p>
                </div>
                <div className="flex   items-center">
                  <p className="text-xs me-2">Id : </p>
                  <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
                    {newListing?.matchId}
                  </p>
                </div>
              </div>

              <div className="flex justify-between items-center">
                <div className="flex mt-2  items-center">
                  <p className="text-xs me-2">Type : </p>
                  <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
                    {newListing?.type}
                  </p>
                </div>
                <div className="flex mt-2  items-center">
                  <p className="text-xs me-2">Fees : </p>
                  <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
                    {newListing?.fees} PKR
                  </p>
                </div>
              </div>
              <div className="flex mt-2  items-center">
                <p className="text-xs me-2">Slots : </p>
                <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
                  {newListing?.participants?.length}/{newListing?.totalSlots}
                </p>
              </div>
              {/* <div className="flex mt-2  items-center">
            <p className="text-xs me-2">Available Slots : </p>
            <p className="inline-block bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2">
              {listing.totalSlots - participants?.length}
            </p>
          </div> */}

              {loading ? (
                <>
                  <ButtonLoading />
                </>
              ) : userParticipation?.length > 0 ||
                authenticated?.user?.role == "admin" ? (
                <Link
                  to={`/dashboard/matchDetails/${newListing?._id}`}
                  className="text-sm rounded-xl  px-4 py-4 bg-red-500 bg-opacity-50 mt-2 text-white-400 hover:underline flex items-center justify-between"
                >
                  <p>See Match Details</p>{" "}
                  <ArrowRight className="h-4 w-4 mr-2" />
                </Link>
              ) : newListing?.participants?.length !==
                newListing?.totalSlots ? (
                <>
                  <Link
                    to={`/dashboard/matchDetails/${newListing?._id}`}
                    className="text-sm  px-4 py-4 rounded-xl bg-gray-900 bg-opacity-50 mt-2 text-green-400 hover:underline flex items-center justify-between"
                  >
                    <p>Join Now</p> <ArrowRight className="h-4 w-4 mr-2" />
                  </Link>
                </>
              ) : newListing?.participants?.length ===
                newListing?.totalSlots ? (
                <>
                  <div className="text-sm  px-4 py-4 rounded-xl bg-gray-900 bg-opacity-50 mt-2 text-green-400 hover:underline flex items-center justify-between">
                    <p>No More Slots</p> <ArrowRight className="h-4 w-4 mr-2" />
                  </div>
                </>
              ) : newListing.status == "finished" ? (
                <>
                  <div className="text-sm  px-4 py-4 rounded-xl bg-gray-900 bg-opacity-50 mt-2 text-green-400 hover:underline flex items-center justify-between">
                    <p>Match Finished</p>{" "}
                    <ArrowRight className="h-4 w-4 mr-2" />
                  </div>
                </>
              ) : newListing.status == "started" ? (
                <>
                  <div className="text-sm  px-4 py-4 rounded-xl bg-gray-900 bg-opacity-50 mt-2 text-green-400 hover:underline flex items-center justify-between">
                    <p>Match Started</p> <ArrowRight className="h-4 w-4 mr-2" />
                  </div>
                </>
              ) : (
                <></>
              )}

              {/* </div> */}
            </div>
          </>
        ) : (
          <>Loading...</>
        )}
      </div>
    </div>
  );
};

export default MatchCard;
